import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IStyleProps {
  index?: number;
  active?: boolean;
}

export const Root = styled.div`
  font-family: Roboto;
  width: 386px;
  height: calc(100vh - 63px);
  background-color: ${C.WHITE};
  justify-content: center;
  box-sizing: border-box;
  padding: 29px 0 6px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
`;

export const Categories = styled.div`
  padding: 0px 35px 19.9px 36px;
  width: 100%;
  height: fit-content;
  border-bottom: 1px solid #dedede;
  display: block;
`;

export const Category = styled.div`
  height: 33px;
  width: 105px;
  flex-grow: 0;
  background-color: ${(props: IStyleProps) => props.active ? C.DARK_BLUE : 'transparent'} ;
  border-radius:${(props: IStyleProps) => props.index===0 ? '20px 0px 0px 20px' : props.index===2 ? '0px 20px 20px 0px' : '0px' }; 
  border: solid 1px #dedede;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${(props: IStyleProps) => props.active ? C.WHITE : C.DARK_GRAY};
  text-transform: uppercase;
  cursor: pointer;
`;

export const Fields = styled.div`
  display: block;
  width: 100%;
  overflow-y: overlay;
  min-height: calc(100vh - 190px);
  max-height: calc(100vh - 190px);
`;

export const Container = styled.div`
  padding-left: 36px;
  &:first-child {
    padding-top: 15.5px;
  }
`;

export const Shortcuts = styled.div`
  height: 39px;
  flex-grow: 0;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.BLUE};
  border-top: 1px solid #dedede;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 16.3px;
`;